import { useAuthContext } from '@repo/user-session';
import { List } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

import { AUTH_PATHS, COMMON_PATHS } from '@/lib/constants/paths';
import { useUrlWithQueryString } from '@/lib/hooks/use-url-with-query-string';

export const WaitingModal = ({ waitingTime, callbackFunction }: { waitingTime: number; callbackFunction?: () => void }) => {
  const router = useRouter();
  const { auth } = useAuthContext();
  const actionUrl = useUrlWithQueryString(auth.status === 'login' ? COMMON_PATHS.환급조회목록 : AUTH_PATHS.로그인);
  const [remainTime, setRemainTime] = useState(waitingTime);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (remainTime < 0) {
      if (timer.current) {
        clearInterval(timer.current);
      }
      return;
    }
    timer.current = setInterval(() => {
      setRemainTime((prev) => prev - 1);
      if (remainTime === 0) {
        if (timer.current) {
          clearInterval(timer.current);
        }
        if (callbackFunction) {
          callbackFunction();
          return;
        }
        router.push(actionUrl);
        return;
      }
    }, 1000);

    return () => {
      if (timer.current) {
        clearInterval(timer.current);
      }
    };
  }, [actionUrl, callbackFunction, remainTime, router]);

  useEffect(() => {
    setRemainTime(waitingTime);
  }, [waitingTime]);

  return (
    <>
      {remainTime > 0 && (
        <div className={'fixed left-0 top-0 z-[110] flex h-full w-full items-end justify-center bg-[rgba(0,0,0,0.4)] sm:items-center'}>
          <div className={'relative m-[8px] w-full max-w-[440px] text-center overflow-hidden rounded-5 bg-white px-7 py-12'}>
            <button
              className={
                'blur-[40px]] absolute right-[1rem] top-[1rem] z-10 flex h-[1.75rem] w-[1.75rem] select-none items-center justify-center rounded-full bg-[rgba(0,0,0,0.24)] text-[1.325rem] text-white'
              }
              onClick={() => setRemainTime(-1)}
            >
              
            </button>
            <div className={'mb-3 font-bold text-24 text-gray-900'}>서비스 접속 대기중</div>
            <div className={'font-normal text-17 text-gray-700 whitespace-pre'}>
              {'접속자가 많아서 잠시 대기가 필요해요.\n대기 후 자동으로 접속 시도할게요.'}
            </div>
            <List.Basic
              title={{
                text: `${remainTime}초`,
                color: 'red.700',
                badge: <img key={'waiting-time'} src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/ic-clock-md.svg`} alt={'clock icon'} />,
                titleStyle: 'headline-26 font-bold flex flex-row-reverse gap-1.5 justify-center reverse py-6'
              }}
            />
            <div className={'font-normal text-15 text-gray-600 whitespace-pre'}>{'*닫기, 새로고침, 뒤로가기 또는 재접속 하시면\n대기 시간이 더 길어져요.'}</div>
          </div>
        </div>
      )}
    </>
  );
};
